// extracted by mini-css-extract-plugin
export default {"skeleton":"ryAzCd","container":"iD6u8N","title":"BqGpQq","skeletons":"QKabL4","loading":"xlZGKS","container-solo":"QdQpNB"};